var _rect, _rect2, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRouteIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.1553,
    y: 21.9242,
    width: 6.05716,
    height: 6.05716,
    rx: 3.02858,
    transform: "rotate(134.495 18.1553 21.9242)",
    stroke: "currentColor",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31.0981,
    y: 32.5182,
    width: 6.05716,
    height: 6.05717,
    rx: 3.02858,
    transform: "rotate(-45.5047 31.0981 32.5182)",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.24 32.4994L28.6741 32.5396C26.7885 32.5562 25.8457 32.5645 25.2548 31.9839C24.6639 31.4033 24.6556 30.4605 24.639 28.575L24.6151 25.8675C24.5985 23.9819 24.5902 23.0391 23.9993 22.4585C23.4084 21.8779 22.4656 21.8862 20.5801 21.9028L16.0141 21.9431",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7646 12.3036V5.42589C14.7646 5.10933 14.7646 4.95105 14.8685 4.87622C14.9723 4.80139 15.1224 4.85144 15.4228 4.95155L24.6988 8.04356C25.2871 8.23967 25.5813 8.33772 25.5813 8.51791C25.5813 8.6981 25.2871 8.79615 24.6988 8.99225L14.7646 12.3036ZM14.7646 12.3036V17.0358V17.9822",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9644 22.9037V16.026C35.9644 15.7094 35.9644 15.5512 36.0682 15.4763C36.172 15.4015 36.3222 15.4515 36.6225 15.5516L45.8985 18.6437C46.4868 18.8398 46.781 18.9378 46.781 19.118C46.781 19.2982 46.4868 19.3962 45.8985 19.5923L35.9644 22.9037ZM35.9644 22.9037V27.6359V28.5823",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRouteIcon);
export default __webpack_public_path__ + "static/media/route-icon.386faeaaa15148a4da5d39b084155d9a.svg";
export { ForwardRef as ReactComponent };